import { useEffect } from 'react';

const useResetSubOption = ({ resetField, subOption = [], trackValue }) => {
    useEffect(() => {
        if (trackValue) {
            if (subOption.length > 0 && resetField && typeof resetField === 'function') {
                subOption.forEach((opt) => {
                    try {
                        resetField(opt);
                    } catch (error) {
                        console.error(error);
                    }
                });
            }
        }
    }, [trackValue]);
};

export default useResetSubOption;
